import React from 'react';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { goToPreviousStep } from '~/store/slices/updateApplication/updateApplication.slice';
import { useUpdateApplicationSelectors } from '~/store/selectors/updateApplication/updateApplication.selector';
import Navbar from '~/components/shared/Navbar/Navbar';

const PreviousStepButton = () => {
  const dispatch = useAppDispatch();
  const {
    allSteps,
    currentStepIndex,
    pendingSteps,
  } = useUpdateApplicationSelectors();

  if (pendingSteps.length === 0) return null;

  const showPreviousStepButton = allSteps.length > 0 && currentStepIndex > -1;

  const handleClick = () => {
    if (showPreviousStepButton) dispatch(goToPreviousStep());
  };

  return showPreviousStepButton ? (
    <Navbar
      data-testid="update-application-previous-button"
      onBackClick={handleClick}
      showBackButton
      progressStepperDots={undefined}
    />
  ) : null;
};

export default PreviousStepButton;
